$(document).ready(function () {
  $('.faq-section').each(function () {
    const $section = $(this);
    const $items = $section.find('.faq-item');

    // Start with all answers closed
    $items.find('.faq-answer').hide();

    $items.find('.faq-question').on('click', function () {
      const $item = $(this).closest('.faq-item');
      const $answer = $item.find('.faq-answer');

      // If already open → close it
      if ($item.hasClass('active')) {
        $item.removeClass('active');
        $answer.stop(true, true).slideUp(300);
      } else {
        // Close others
        $items.removeClass('active')
              .find('.faq-answer')
              .stop(true, true)
              .slideUp(300);

        // Open current
        $item.addClass('active');
        $answer.stop(true, true).slideDown(300);
      }
    });
  });
});
